import React, { ComponentPropsWithRef } from 'react'
import { twMerge } from 'tailwind-merge'
import { ImgMap } from '../utils/img'
import demo from '../assets/imagesset/demo.png'

interface Props extends ComponentPropsWithRef<'img'> {
    valueKey?: string
    iconSizePreset?: 'compact' | 'normal' | 'medium' | 'big'
    iconSize?: string
}

const iconSizePresets = {
    compact: 'h-8 w-auto',
    normal: 'h-10 w-auto',
    medium: 'h-12 w-auto',
    big: 'h-24 w-auto',
}

export const ValuePicto = (p: Props) => {
    const {
        className,
        valueKey = '',
        iconSizePreset = 'normal',
        iconSize = iconSizePresets[iconSizePreset],
        ...rest
    } = p
    return (
        // FIXME Warning: validateDOMNesting(...): <div> cannot appear as a descendant of <p>.
        <div
            className={twMerge(
                // 'border-1 border-black border-solid',
                '',
                className
            )}
            {...rest}
        >
            <img
                loading='lazy'
                className={`${iconSize} object-contain p-1 pointer-events-none`}
                src={ImgMap[valueKey]}
            />
            {/* <Typography className={`text-black ${iconSize}`} variant="caption">{big}</Typography> */}
        </div>
    )
}
